<template>
  <div
    :id="modalId"
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
    data-keyboard="false"
    data-backdrop="static">
    <div
      class="modal-dialog "
      role="document">
      <div class="modal-content">
        <div
          class="modal-header"
          style="border-bottom: none;">
          <h5 class="modal-title">
            {{ $t('message.areyousuretoclonethisdocument') }}
          </h5>
          <button
            v-if="!loading"
            type="button"
            class="close"
            aria-label="Close"
            @click="onClose">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div
          v-if="!loading"
          class="modal-footer">
          <button
            type="button"
            class="btn btn-light"
            @click="onCancel">{{ $t('button.cancel') }}</button>
          <button
            type="button"
            class="btn btn-web"
            @click="onConfirm">{{ $t('button.clone') }}</button>
        </div>
        <div
          v-else
          class="modal-footer">
          <button
            type="button"
            class="btn btn-light"
            disabled>{{ $t('button.cancel') }}</button>
          <button
            type="button"
            class="btn btn-web"
            disabled>
            <i class="fas fa-spinner spin"/>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { uuid } from 'vue-uuid'

export default {
  props: ['show', 'loading'],

  data() {
    return {
      id: uuid.v1(),
    }
  },

  computed: {
    modalId() {
      return `${this.id}-confirmCloneModal`
    },
  },

  watch: {
    show () {
      if (this.show) {
        $(`#${this.modalId}`).modal('show')
      } else {
        $(`#${this.modalId}`).modal('hide')
      }
    },
  },

  mounted () {
    this.setModal(`#${this.modalId}`)
    if (this.show) {
      $(`#${this.modalId}`).modal('show')
    }
  },

  destroyed () {
    this.leavePage(this.$Progress)
  },

  methods: {
    onClose () {
      this.$emit('onClose')
    },
    onCancel () {
      this.$emit('onCancel')
    },
    onConfirm () {
      this.$emit('onConfirm')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseConfirmCloneModal.vue